<template>
  <button v-if="isDisplayButton" class="btn_blue_round btn_md btn text-white" @click="onCsvExport">CSVエクスポート</button>
  <!-- その他ボタンから表示される場合 -->
  <div v-else class="o_button" @click="onCsvExport">
    <span>CSVエクスポート</span>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'
import HTTPClient from './../../common/http-client'
import FlashMessage from '../../common/flash-message.component'
import RouterUtils from '../../_helpers/router.util'
import { mapGetters } from 'vuex'
import { decodeFilenameMixin } from '../../mixins/decodeFileName'
export default {
  props: {
    mappingNo: {
      type: String,
      default: 'ie-item'
    },
    isDisplayButton: true,
    currentQueryInStorage: {
      type: String,
      default: ''
    },
    onExportSuccess: {
      type: Function,
      default: null
    }
  },
  mixins: [decodeFilenameMixin],
  methods: {
    ...mapGetters('socket', ['isSocketEnabled']),
    async onCsvExport() {
      this.$emit('is-loading', true)
      this.$emit('on-export')
      try {
        const response = await HTTPClient.getInstance().httpBlob.post(
          `/table/ie/export/all/${this.mappingNo}${this.currentUrlQueryStr()}`
        )
        if (!response.data || !response.data.size) {
          this.$emit('is-loading', false)
          // バックエンドから返ったきたCSVファイルnullだった場合
          FlashMessage.getInstance().showErrorMessage('ファイルをダウンロードしようとしましたが、データがありませんでした。')
          return
        }
        const blob = new Blob([response.data], {
          type: 'text/csv'
        })
        // レスポンスヘッダからファイル名を取得します
        const contentDisposition = response.headers['content-disposition']
        const filename = this.decodeFileName(contentDisposition)
        // ダウンロードします
        saveAs(blob, `${filename}.csv`)
        this.$emit('is-loading', false)
        this.onExportSuccess && this.onExportSuccess()
      } catch (error) {
        this.$emit('is-loading', false)
        FlashMessage.getInstance().parseAndShowErrorMessage(error)
      }
    },
    currentUrlQueryStr() {
      var queryStr = ''
      if (this.isSocketEnabled()) {
        queryStr = this.currentQueryInStorage
      } else {
        queryStr = RouterUtils.getQueryString(this.$route.name)
      }
      // URLにあるOffsetとLimitを取り除く
      queryStr = queryStr.replace(/&?offset=\d+|&?limit=\d+/g, '')
      return queryStr
    }
  }
}
</script>
<style lang="scss" scoped>
div.o_button:hover {
  background-color: #67A3C7;
  color: #ffffff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/CsvExportButton.vue